const navLinks = document.querySelectorAll(".navigation-in-page__list a");

const sections = Array.from(navLinks)
  .map((link) => {
    const sectionId = link.getAttribute("href").substring(1);
    return document.getElementById(sectionId);
  })
  .filter(Boolean);

const observerOptions = {
  root: null,
  rootMargin: "-75px 0px -75% 0px",
  threshold: 0,
};

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      navLinks.forEach((link) => {
        link.parentElement.classList.remove("active");
      });

      const activeLink = document.querySelector(`.navigation-in-page__list a[href="#${entry.target.id}"]`);
      if (activeLink) {
        activeLink.parentElement.classList.add("active");
      }
    }
  });
}, observerOptions);

sections.forEach((section) => {
  if (section) {
    observer.observe(section);
  }
});

const slider = document.querySelector(".navigation-in-page");

if (slider) {
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener("mousedown", startDragging);
  slider.addEventListener("mouseleave", stopDragging);
  slider.addEventListener("mouseup", stopDragging);
  slider.addEventListener("mousemove", drag);

  function startDragging(e) {
    isDown = true;
    slider.style.cursor = "grabbing";
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  }

  function stopDragging() {
    isDown = false;
    slider.style.cursor = "grab";
  }

  function drag(e) {
    if (!isDown) return;

    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2;
    slider.scrollLeft = scrollLeft - walk;
  }

  slider.style.cursor = "grab";
  slider.style.userSelect = "none";
}
